export const FILTER_MANUFACTURERS = 'FILTER_MANUFACTURERS'
export const FILTER_CATEGORIES = 'FILTER_CATEGORIES'
export const FILTER_ATTRS = 'FILTER_ATTRS'
export const RESET_FILTERS = 'RESET_FILTERS'
export const RESUME_FILTERS = 'RESUME_FILTERS'

export const FILTER_COLOR = 'FILTER_COLOR'
export const FILTER_PRICE = 'FILTER_PRICE'
export const SORT_BY = 'SORT_BY'
export const RESET_PRODUCTS_FILTERS = 'RESET_PRODUCTS_FILTERS'